import Vue from 'vue'
import { VueChatEmoji } from 'vue-chat-emoji'
Vue.component('Emoji', VueChatEmoji)
import 'vue-chat-emoji/dist/vue-chat-emoji.min.css'
require('vue-chat-emoji/dist/vue-chat-emoji.min.css')
Vue.config.productionTip = false
